import { render, staticRenderFns } from "./DocusignAfterSignMappingsManagement.vue?vue&type=template&id=32d027bb&"
import script from "./DocusignAfterSignMappingsManagement.vue?vue&type=script&lang=ts&"
export * from "./DocusignAfterSignMappingsManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports